export type ElementRect = { x: number; y: number; width: number; height: number }

/**
 * Compute the axis-aligned bounding box (AABB) of a potentially-rotated element.
 * When rotation is 0, returns the original rect unchanged.
 */
export const getElementAABB = (rect: ElementRect, rotation: number): ElementRect => {
  if (rotation === 0) return rect
  const rad = (rotation * Math.PI) / 180
  const cos = Math.abs(Math.cos(rad))
  const sin = Math.abs(Math.sin(rad))
  const halfAABBw = (rect.width * cos + rect.height * sin) / 2
  const halfAABBh = (rect.width * sin + rect.height * cos) / 2
  const cx = rect.x + rect.width / 2
  const cy = rect.y + rect.height / 2

  return {
    x: cx - halfAABBw,
    y: cy - halfAABBh,
    width: halfAABBw * 2,
    height: halfAABBh * 2,
  }
}

/**
 * Grid positions used for snap lines and the visual grid overlay (thirds + center).
 */
export const getGridPositions = (
  w: number,
  h: number,
): { x: number[]; y: number[] } => ({
  x: [w / 3, w / 2, (2 * w) / 3],
  y: [h / 3, h / 2, (2 * h) / 3],
})
